import { addToURL, genericSwitchContent } from './sidebar';
import { toggleFilterDropdown, stickyFilter } from './filter';
import { scrollToSection } from './scroll-to';

const showContent = ( classnameLists ) => {
  let url = window.location.href;
  let slug = url.split( '#' )[1];

  if ( slug ) {
    $( classnameLists.sidebarTabName + '[data-tab-name="' +
      slug + '"]' ).first().addClass( 'active' );
    $( classnameLists.content + '[data-tab-name="' + slug + '"]' ).addClass( 'active' );

    $( '.generic-tab-content .rp-selection' )
      .text( $( classnameLists.sidebarTabName + '[data-tab-name="' + slug + '"]' ).first().text() );

  } else {
    $( classnameLists.content ).first().addClass( 'active' );
    $( classnameLists.sidebarTabName ).first().addClass( 'active' );
    $( '.generic-tab-content .rp-selection' )
      .text( $( classnameLists.sidebarTabName ).first().text() );
  }

  $( classnameLists.contentWrapper ).removeClass( 'hidden-content' );
};

const changeContentBySidebar = ( classnameLists ) => {
  let tabs = $( classnameLists.sidebarTabName );

  tabs.on( 'click', function() {
    let currTabName = $( this ).data( 'tab-name' );
    let activeTabName = $( classnameLists.sidebarTabName + '.active' ).data( 'tab-name' );
    if ( currTabName !== activeTabName ) {
      if ( currTabName === 'all' ) {
        addToURL( 'All', false );
      } else {
        addToURL( $( this ).text(), currTabName );
      }
      genericSwitchContent({
        allCase:       'all',
        activeClass:   'active',
        dataLabel:     'tab-name',
        oldSidebar:    classnameLists.sidebarTabName + '.active',
        activeSidebar: classnameLists.sidebarTabName + '[data-tab-name="' + currTabName + '"]',
        oldContent:    classnameLists.content + '.active',
        allContent:    classnameLists.content + ' .tab-content',
        activeContent: classnameLists.content + '[data-tab-name="' + currTabName + '"]',
      }, currTabName );
    }
  });
};

const initTabInteractions = ( target ) => {
  let classnameLists = {
    sidebarWrapper: target + ' ' + target + '__sidebar__wrapper',
    sidebar:        target + ' ' + target + '__sidebar',
    sidebarTabName: target + ' ' + target + '__sidebar .sidebar-name',
    contentWrapper: target + ' ' + target + '__content__wrapper',
    content:        target + ' ' + target + '__content__wrapper .tab-content',
  };

  showContent( classnameLists );
  changeContentBySidebar( classnameLists );

  let dropdown = target + ' .refine-results-bar .text';
  let sidebar = target + target + '__sidebar';
  toggleFilterDropdown( dropdown, sidebar );
};

const rpDropDown = () => {

  jQuery( '.generic-tab-content .rp-selection' ).click( ( event ) => {

    jQuery( event.currentTarget ).toggleClass( 'opened' );
    jQuery( event.currentTarget ).next().slideToggle();

  });

  jQuery( '.generic-tab-content .rp-options .sidebar-name' ).click( ( event ) => {

    jQuery( event.currentTarget ).parent().prev().toggleClass( 'opened' );
    jQuery( event.currentTarget ).parent().slideToggle();
    jQuery( '.generic-tab-content .rp-selection' ).text( jQuery( event.currentTarget ).text() );

  });

};

scrollToSection( '.generic-tab-content' );

$( document ).ready( function() {
  stickyFilter( '.generic-tab-content .refine-results-bar' );
  initTabInteractions( $( '.generic-tab-content' ).data( 'generic-tab' ) );
  rpDropDown();
});
